import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [checked, setChecked] = useState(false);

    const fetchMe = useCallback(async () => {
        const token = localStorage.getItem("cdc_token");
        if (!token) {
            setUser(null);
            setChecked(true);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (_e) {
            localStorage.removeItem("cdc_token");
            setUser(null);
        } finally {
            setChecked(true);
        }
    }, []);

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    const login = useCallback(async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.token) localStorage.setItem("cdc_token", data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
        }
    }, []);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } catch (_e) {
            // ignore
        }
        localStorage.removeItem("cdc_token");
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, checked, login, logout, refresh: fetchMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
